import { Children, type ReactNode } from 'react';

import { getXAxisConfig } from './get-x-axis-config.js';
import { isSlot } from '../../../../../core/utils/is-slot.js';
import { defaultXAxisConfig, defaultYAxisConfig } from '../constants.js';
import { Threshold } from '../slots/Threshold.js';
import { XAxis } from '../slots/XAxis.js';
import { YAxis } from '../slots/YAxis.js';
import type { SparklineThresholdProps } from '../types/sparkline-thresholds-props.js';
import { SparklineXAxisInternalProps } from '../types/sparkline-x-axis-props.js';
import type { SparklineYAxisProps } from '../types/sparkline-y-axis-props.js';

export interface SparklineConfig {
  thresholds: SparklineThresholdProps[];
  xAxis: SparklineXAxisInternalProps;
  yAxis: SparklineYAxisProps;
}

export function iterateSparklineSlots(children: ReactNode): SparklineConfig {
  const thresholds: SparklineThresholdProps[] = [];
  let yAxis: SparklineYAxisProps = defaultYAxisConfig;
  let xAxis: SparklineXAxisInternalProps = defaultXAxisConfig;

  Children.forEach(children, (child) => {
    if (isSlot(child, Threshold)) {
      const thresholdProps = child.props;
      thresholds.push(thresholdProps);
    } else if (isSlot(child, XAxis)) {
      xAxis = getXAxisConfig(child.props);
    } else if (isSlot(child, YAxis)) {
      yAxis = {
        ...yAxis,
        ...child.props,
      };
    }
  });

  return {
    thresholds,
    xAxis,
    yAxis,
  };
}
